import metaTags from '../components/meta-tags/definitions';

import LandingPage from '../areas/landing-page';

import Product from '../areas/product';
import ProductAlert from '../areas/product-alert';
import ProductCompare from '../areas/product-compare';

import Category from '../areas/category';

import Services from '../areas/services';

import Store from '../areas/store';
import Brand from '../areas/brand';

import Info from '../areas/info';

import Themes from '../areas/campaign/themes';
import Campaign from '../areas/campaign';

import GiftGuide from '../areas/gift-guide';
import NewsletterVerification from '../areas/newsletter-verification';
import Article from '../areas/article';

import Search from '../areas/search';

import TrackingSettings from '../areas/user/tracking-settings-loadable';
import Personalization from '../areas/user/personalization-loadable';

import {
  AccountManager,
  SignupConfirm,
  SettingsPage,
  EmailChangeConfirm,
  RecoverLinkSent,
  VerifyEmail,
} from '../areas/account';

import AlertUnsubscribePage from '../areas/alerts/unsubscribe';

import {
  ShopOfTheYearWinners,
  ShopOfTheYearCategoryNominees,
} from '../areas/shop-of-the-year';

import ShopOfTheYear from '../areas/shop-of-the-year/shop-of-the-year';

export default {
  start: {
    path: '/',
    component: LandingPage,
    showError: false,
    metaTags: metaTags.start,
    cacheControl: {
      maxAge: '1h',
      maxStale: '30m',
    },
  },
  newsletterVerify: {
    path: '/newsletter/verify',
    component: NewsletterVerification,
  },
  search: {
    path: '/search',
    component: Search,
    metaTags: metaTags.search,
  },
  services: {
    path: '/tjanster--cv1004',
    component: Services,
    metaTags: metaTags.services,
  },
  productAlert: {
    path: '*--p:id/alert',
    relativePath: '/alert',
    component: ProductAlert,
    metaTags: metaTags.productAlert,
  },
  productCompare: {
    path: '/compare/products/:productIds?',
    component: ProductCompare,
    metaTags: metaTags.productCompare,
  },
  product: {
    path: '*--p:id(\\d+)/:section(properties|reviews|statistics)?',
    component: Product,
    metaTags: metaTags.product,
    cacheControl: {
      maxAge: '12h',
      maxStale: '30m',
    },
  },
  category: {
    path: '*--c:id([sv]?\\d+)',
    component: Category,
    metaTags: metaTags.category,
    cacheControl: {
      maxAge: '4h',
      maxStale: '30m',
    },
  },
  store: {
    path: '*--s:id(\\d+)',
    component: Store,
    metaTags: metaTags.store,
  },
  brand: {
    path: '*--b:id(\\d+)',
    component: Brand,
    metaTags: metaTags.brand,
  },
  infoPage: {
    path: '*--i:id(\\d+)',
    component: Info,
    metaTags: metaTags.infoPage,
    cacheControl: {
      maxAge: '1h',
      maxStale: '30m',
    },
  },
  article: {
    path: '*--a:id(\\d+)',
    component: Article,
    metaTags: metaTags.article,
    cacheControl: {
      maxAge: '1h',
      maxStale: '30m',
    },
  },
  giftGuide: {
    // HACK: Must include all current running giftGuides, hardcoded
    path: '/campaigns/:name(gift-guide|another-gift-guide)/:list?',
    component: GiftGuide,
    metaTags: metaTags.campaign,
  },
  themes: {
    path: '/campaigns',
    component: Themes,
    metaTags: metaTags.campaign,
    cacheControl: {
      maxAge: '4h',
      maxStale: '30m',
    },
  },
  campaign: {
    path: '/campaigns/:name?',
    // Campaign pages uses AWS and elasticsearch internally for performance
    // and load reasons, we don't want to trigger a new fetch on url change.
    fetchStrategy: 'initial-only',
    component: Campaign,
    metaTags: metaTags.campaign,
    cacheControl: {
      maxAge: '4h',
      maxStale: '30m',
    },
  },
  signup: {
    path: '/signup',
    component: AccountManager,
    metaTags: metaTags.generic,
  },
  login: {
    path: '/login',
    component: AccountManager,
    metaTags: metaTags.generic,
    props: {
      recaptchaEnabled: false,
    },
  },
  forgotPassword: {
    path: '/forgot-password',
    component: AccountManager,
    metaTags: metaTags.generic,
    props: {
      subHeading: true,
    },
  },
  forgotPasswordChange: {
    path: '/forgot-password/change',
    component: AccountManager,
    props: {
      subHeading: true,
    },
    metaTags: metaTags.generic,
  },
  signupConfirm: {
    path: '/signup/confirm',
    component: SignupConfirm,
    metaTags: metaTags.generic,
  },
  settings: {
    path: '/account/settings',
    component: SettingsPage,
    metaTags: metaTags.generic,
  },
  emailChangeConfirm: {
    path: '/account/settings/email-change/confirm',
    component: EmailChangeConfirm,
    metaTags: metaTags.generic,
  },
  forgotPasswordEmailSent: {
    path: '/forgot-password/email-sent',
    component: RecoverLinkSent,
    metaTags: metaTags.generic,
  },
  trackingSettings: {
    path: '/privacy-settings',
    component: TrackingSettings,
    metaTags: metaTags.generic,
  },
  alertUnsubscribe: {
    path: '/alerts/unsubscribe',
    component: AlertUnsubscribePage,
    metaTags: metaTags.generic,
  },
  verifyEmail: {
    path: '/verify-email',
    component: VerifyEmail,
    metaTags: metaTags.generic,
  },
  shopOfTheYear: {
    path: '/shop-of-the-year',
    component: ShopOfTheYear,
    metaTags: metaTags.shopOfTheYear,
  },
  shopOfTheYearWinners: {
    path: '/shop-of-the-year/:year/winners',
    component: ShopOfTheYearWinners,
    metaTags: metaTags.shopOfTheYearWinners,
  },
  shopOfTheYearCategory: {
    path: '/shop-of-the-year/:year/category/:id',
    component: ShopOfTheYearCategoryNominees,
    metaTags: metaTags.shopOfTheYearCategory,
  },
  personalization: {
    path: '/personalization',
    component: Personalization,
    metaTags: metaTags.generic,
  },
};
